var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlansModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 229,
    viewBox: "0 0 334 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8468 168.434H62.9336C66.5322 168.434 69.5879 171.073 70.1159 174.637L77.0359 221.342H15.2684L8.66453 176.771C8.0761 172.799 10.8147 169.102 14.7813 168.513C15.1341 168.46 15.4902 168.434 15.8468 168.434Z",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1749 168.434H71.2618C74.8603 168.434 77.916 171.073 78.444 174.637L85.364 221.342H23.5965L16.9927 176.771C16.4042 172.799 19.1428 169.102 23.1095 168.513C23.4622 168.46 23.8183 168.434 24.1749 168.434Z",
    fill: "#E5E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.319 43.0132H258.063C290.979 43.0132 317.663 69.7299 317.663 102.687C317.663 135.643 290.979 162.36 258.063 162.36H60.5073V139.944C60.5073 86.4108 103.851 43.0132 157.319 43.0132Z",
    fill: "#DBFFF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.254 0H218.129C226.984 0 234.163 7.18773 234.163 16.0542C234.163 24.9207 226.984 32.1085 218.129 32.1085H165.185C165.185 14.3755 179.543 0 197.254 0Z",
    fill: "#DBFFF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.225 20.5979H95.2989C83.4358 20.5979 73.8189 30.2267 73.8189 42.1045C73.8189 53.9823 83.4358 63.6111 95.2989 63.6111H165.185C165.185 39.8556 145.951 20.5979 122.225 20.5979Z",
    stroke: "#18233D",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.447 46.6482C106.324 46.6482 107.846 45.1564 107.846 43.3161C107.846 41.4759 106.324 39.9841 104.447 39.9841C102.569 39.9841 101.047 41.4759 101.047 43.3161C101.047 45.1564 102.569 46.6482 104.447 46.6482Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.502 46.6482C121.379 46.6482 122.901 45.1564 122.901 43.3161C122.901 41.4759 121.379 39.9841 119.502 39.9841C117.624 39.9841 116.102 41.4759 116.102 43.3161C116.102 45.1564 117.624 46.6482 119.502 46.6482Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.557 46.6482C136.435 46.6482 137.957 45.1564 137.957 43.3161C137.957 41.4759 136.435 39.9841 134.557 39.9841C132.68 39.9841 131.157 41.4759 131.157 43.3161C131.157 45.1564 132.68 46.6482 134.557 46.6482Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8468 168.434H62.9336C66.5322 168.434 69.5879 171.073 70.1159 174.637L77.0359 221.342H15.2684L8.66453 176.771C8.0761 172.799 10.8147 169.102 14.7813 168.513C15.1341 168.46 15.4902 168.434 15.8468 168.434Z",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1749 168.434H71.2618C74.8603 168.434 77.916 171.073 78.444 174.637L85.364 221.342H23.5965L16.9927 176.771C16.4042 172.799 19.1428 169.102 23.1095 168.513C23.4622 168.46 23.8183 168.434 24.1749 168.434Z",
    fill: "#E5E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8977 212.175L121.453 215.107C131.14 215.848 136.633 217.694 137.932 220.646H91.8977V212.175Z",
    fill: "#FFD1AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5436 170.418C70.318 174.008 75.1698 181.012 79.0992 191.43C83.0286 201.848 85.2851 207.985 85.8687 209.842L93.5373 211.086L93.5373 225.225C86.692 225.027 81.9006 223.739 79.1633 221.361C73.4062 216.361 70.2695 208.806 65.2232 196.287C62.7232 190.085 60.6631 185.803 60.0113 182C58.8611 175.29 60.3719 171.429 64.5436 170.418Z",
    fill: "#C6CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1627 169.796C36.5685 174.167 30.7715 178.627 30.7715 183.176C30.7715 187.724 33.67 196.174 39.4671 208.525C38.0604 218.252 37.3571 224.05 37.3571 225.919C37.3571 228.721 65.8938 230.697 75.8572 223.696C80.2178 221.016 74.2325 207.881 74.2325 199.14C77.6596 195.118 77.3844 191.117 71.5544 180.749C69.1796 176.525 67.2182 171.601 63.8497 169.813C62.4201 169.054 59.771 169.049 55.9024 169.796H48.1627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7161 166.361C35.4591 148.054 37.4184 136.908 41.5943 132.922C45.7701 128.937 51.3601 128.266 58.3644 130.908C61.084 130.651 63.0513 131.28 64.2665 132.796C66.0891 135.069 66.4538 139.805 61.578 142.643C59.0641 144.107 61.88 157.591 64.2665 165.579C62.8511 167.324 53.3343 167.584 35.7161 166.361Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2736 151.03C50.3168 163.114 49.2627 170.254 45.1113 172.449L60.0223 177.475L61.5716 171.219C60.1662 168.859 58.8436 162.594 57.6036 152.422L48.2736 151.03Z",
    fill: "#FFD1AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5493 150.965L57.0684 148.953C57.0871 148.964 57.1059 148.974 57.1247 148.984L58.6503 159.928C53.5591 157.3 50.1921 154.312 48.5493 150.965Z",
    fill: "#CF8B54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.595 138.302C67.5246 149.402 67.2846 155.792 63.8748 157.474C58.7601 159.996 49.2578 152.543 48.1255 151.49C45.6806 152.327 44.0046 152.054 43.0976 150.671C41.7371 148.597 41.9191 146.125 45.9583 146.125C49.9975 146.125 58.7612 141.671 59.6515 136.08C61.712 135.188 63.3599 135.928 64.595 138.302Z",
    fill: "#FFD1AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5887 140.587C61.5847 141.104 61.2347 142.453 62.5384 144.635C63.4505 146.05 64.3503 147.486 65.2377 148.941H63.2198",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7231 148.941L47.1932 149.638",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6726 143.09C55.9234 141.961 57.1061 141.516 58.2205 141.757",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2975 144.764C58.6808 144.764 58.9915 144.453 58.9915 144.068C58.9915 143.684 58.6808 143.372 58.2975 143.372C57.9142 143.372 57.6035 143.684 57.6035 144.068C57.6035 144.453 57.9142 144.764 58.2975 144.764Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8495 143.372C64.2328 143.372 64.5436 143.06 64.5436 142.676C64.5436 142.292 64.2328 141.98 63.8495 141.98C63.4662 141.98 63.1555 142.292 63.1555 142.676C63.1555 143.06 63.4662 143.372 63.8495 143.372Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0737 151.726H64.5438C64.4816 152.654 63.9881 153.118 63.0631 153.118C62.1382 153.118 61.4751 152.654 61.0737 151.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2468 207.02C76.2015 211.682 77.4808 216.412 77.4476 219.723C74.3651 220.696 70.84 221.3 66.8723 221.534C56.7454 222.133 46.3183 214.895 35.5909 199.821C35.2524 199.009 34.9317 198.22 34.6289 197.456C46.7678 199.445 53.2615 200.439 54.1099 200.439C54.7738 200.439 61.8195 202.633 75.2468 207.02Z",
    fill: "#58627A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3284 197.179L101.9 175.303L109.445 164.394L115.206 157.695C115.619 157.216 116.341 157.16 116.822 157.571C117.322 157.999 117.436 158.728 117.091 159.289L111.827 167.835C113.758 167.422 114.826 168.144 115.031 170.002C115.339 172.788 116.86 171.562 116.86 173.978C116.86 176.393 117.455 177.089 115.952 178.069C114.951 178.723 112.33 180.072 108.091 182.116L86.9277 205.618L77.3284 197.179Z",
    fill: "#FFD1AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7714 181.527C28.6356 185.784 28.3074 198.7 51.2638 212.27C66.5681 221.316 79.5473 218.403 90.2014 203.532L78.8888 194.506L68.5217 203.532C59.0283 196.113 51.8968 190.455 47.1274 186.556C39.9732 180.709 32.9073 177.27 30.7714 181.527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9623 199.897L65.5861 204.063L64.6904 208.75",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.586 204.323C64.736 203.535 56.4915 196.566 40.8525 183.418",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.914 226.609H243.937L251.01 161.721C251.395 158.187 254.377 155.51 257.927 155.51H304.905C305.157 155.51 305.409 155.523 305.66 155.551C309.48 155.968 312.239 159.408 311.822 163.233L304.914 226.609Z",
    stroke: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.577 155.207H249.599C245.894 155.207 242.783 158 242.381 161.688L235.272 226.912H296.857L303.795 163.265C304.23 159.274 301.351 155.685 297.365 155.25C297.103 155.221 296.84 155.207 296.577 155.207V155.207Z",
    fill: "#E5E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.207 219.95H0V228.304H115.207V219.95Z",
    fill: "#A7C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.363 179.27H208.859L214.137 119.727C214.625 114.222 218.406 109.744 223.432 108.171H155.432C148.765 108.171 143.177 113.218 142.492 119.858L136.363 179.27Z",
    fill: "white",
    stroke: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.597 107.868C158.348 107.868 162.2 111.724 162.2 116.481C162.2 116.812 162.181 117.143 162.143 117.472L161.775 120.647H234.947C236.821 115.817 234.428 110.38 229.604 108.504C228.522 108.084 227.372 107.868 226.211 107.868H153.597Z",
    fill: "#85A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.977 144.488L99.5713 165.436H128.305L130.71 144.488H101.977Z",
    stroke: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.818 155.665H115.534",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.75 150.979H125.776",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.284 153.322H111.345",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.353 157.539H109.008",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.664 157.539H118.319",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.82 199.278L204.279 211.499C200.999 212.516 196.209 215.333 189.91 219.95L212.193 220.757C216.607 217.939 221.6 212.802 227.171 205.346L210.82 199.278Z",
    fill: "#FFD1AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.62 161.381C245.783 162.893 239.54 164.46 234.891 166.082C230.242 167.704 221.987 178.574 210.125 198.692L222.779 210.782L230.654 201.154C231.255 215.228 234.365 223.606 239.985 226.286H284.88C288.287 223.965 291.568 212.764 294.723 192.684L306.259 201.007L313.696 181.057C301.771 171.392 294.663 166.401 292.372 166.082C290.08 165.763 280.178 163.53 262.665 159.384L253.62 161.381Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.277 159.687L249.806 162.206V173.223L256.912 166.4L265.883 165.696L275.463 171.615L274.319 162.225L268.11 159.687H255.277Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.424 163.864H259.171V182.75H263.424V163.864Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.668 198.779C209.666 197.602 208.209 200.364 206.586 203.181C204.963 205.997 203.632 206.111 206.569 207.933C209.505 209.755 219.897 219.452 221.447 217.943C222.997 216.433 222.65 212.153 223.949 211.828C225.249 211.503 227.178 210.626 224.266 207.547C221.354 204.467 213.669 199.957 211.668 198.779Z",
    fill: "#85A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.842 199.169C307.707 205.336 312.586 208.045 318.477 207.298C327.314 206.177 327.821 186.974 323.689 183.389C319.556 179.804 313.208 173.915 306.758 178.413C302.458 181.411 301.486 188.33 303.842 199.169Z",
    fill: "#85A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.563 191.13C323.855 197.88 321.463 206.178 314.536 205.449C307.609 204.719 305.266 192.275 308.646 177.446C310.899 167.559 313.999 154.574 317.947 138.49L317.797 138.271C314.908 134.067 312.859 129.343 311.763 124.361L310.066 120.9C309.838 120.435 309.994 119.874 310.428 119.594C310.887 119.299 311.48 119.319 311.917 119.645L312.848 120.339C313.941 121.154 314.852 122.189 315.52 123.378L317.239 126.435L317.225 110.987C317.225 110.268 317.77 109.666 318.486 109.597C319.185 109.53 319.81 110.037 319.887 110.736L321.117 121.851L323.395 109.032C323.527 108.291 324.209 107.777 324.958 107.856C325.703 107.935 326.258 108.582 326.221 109.331L325.588 122.322L329.322 112.7C329.586 112.019 330.339 111.668 331.029 111.904C331.717 112.139 332.095 112.878 331.882 113.574C329.675 120.782 328.689 124.244 328.925 123.958C329.152 123.683 330.09 122.012 331.739 118.945L331.739 118.945C332.02 118.422 332.646 118.19 333.2 118.403C333.739 118.61 334.016 119.21 333.823 119.755L329.723 131.353L327.671 139.015C326.071 169.258 325.035 186.63 324.563 191.13Z",
    fill: "#FFD1AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.537 125.761C321.887 128.602 323.963 130.962 323.766 132.84",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.906 124.142C327.305 122.227 323.908 121.382 319.717 121.607",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253 139.479C254.18 143.932 254.475 148.362 253.885 152.769C253 159.379 253 161.942 251.571 162.998C255.156 166.88 258.725 168.821 262.278 168.821C265.83 168.821 269.241 166.88 272.509 162.998C270.41 162.053 269.361 159.069 269.361 154.048C269.361 149.028 269.504 143.462 269.789 137.352L253 139.479Z",
    fill: "#FFD1AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.764 138.394C247.082 132.677 245.94 121.898 253.957 119.523C254.501 111.396 272.745 114.909 275.066 123.568C277.388 132.228 272.612 144.489 265.893 145.958C259.174 147.426 254.446 144.111 250.764 138.394Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.775 142.71C269.638 143.806 269.186 149.036 269.33 154.324C269.362 155.523 269.511 156.919 269.775 158.514C260.196 153.995 255 150.818 254.185 148.982C254.241 147.074 254.132 145.24 253.957 143.679L269.775 142.71Z",
    fill: "#CF8B54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.786 131.67C254.987 130.386 255.615 127.857 257.086 123.568C260.886 129.639 264.508 130.151 270.722 131.66C270.318 142.651 271.422 132.702 272.549 132.825C272.778 132.755 273.021 132.718 273.273 132.718C274.691 132.718 275.84 133.906 275.84 135.372C275.84 136.838 274.691 138.026 273.273 138.026C272.612 138.026 272.009 137.768 271.554 137.343C269.474 143.566 265.099 151.553 260.186 150.806C256.634 150.265 253.846 145.717 251.824 137.159C251.649 137.198 251.468 137.218 251.283 137.218C249.865 137.218 248.716 136.03 248.716 134.564C248.716 133.098 249.865 131.91 251.283 131.91C251.383 131.91 251.361 136.179 251.824 136.015C252.132 135.905 252.453 134.457 252.786 131.67Z",
    fill: "#FFD1AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.759 133.855C261.095 135.135 260.619 137.474 259.332 140.87L261.36 141.594",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.615 131.691C265.111 130.971 266.629 131.109 268.17 132.103",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.441 131.92C255.854 131.047 257.378 131.024 259.013 131.851",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.915 134.579C265.309 134.579 265.629 134.257 265.629 133.861C265.629 133.464 265.309 133.142 264.915 133.142C264.521 133.142 264.201 133.464 264.201 133.861C264.201 134.257 264.521 134.579 264.915 134.579Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.349 134.579C256.744 134.579 257.063 134.257 257.063 133.861C257.063 133.464 256.744 133.142 256.349 133.142C255.955 133.142 255.635 133.464 255.635 133.861C255.635 134.257 255.955 134.579 256.349 134.579Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.709 143.526L263.064 143.195C262.652 144.664 261.926 145.399 260.886 145.399C259.847 145.399 259.121 144.775 258.709 143.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.509 136.015L273.937 135.536",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.571 135.057L250.143 134.579",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.66 122.132C262.185 126.542 266.151 129.254 271.557 130.27",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.836 151.03L126.178 151.03C125.192 151.03 124.372 151.79 124.296 152.774L120.504 201.884C120.423 202.925 121.201 203.834 122.24 203.914C122.289 203.918 122.337 203.92 122.386 203.92H199.045C200.031 203.92 200.851 203.16 200.927 202.175L204.719 153.066C204.799 152.025 204.021 151.116 202.982 151.036C202.934 151.032 202.885 151.03 202.836 151.03V151.03Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.084 151.03L127.425 151.03C126.439 151.03 125.619 151.79 125.543 152.774L121.751 201.884C121.671 202.925 122.448 203.834 123.488 203.914C123.536 203.918 123.585 203.92 123.633 203.92H200.292C201.278 203.92 202.098 203.16 202.174 202.175L205.966 153.066C206.046 152.025 205.269 151.116 204.229 151.036C204.181 151.032 204.132 151.03 204.084 151.03V151.03Z",
    fill: "#E5E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.567 187.267L148.269 203.92H176.492L173.353 188.448L155.567 187.267Z",
    fill: "#58627A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.146 187.267H155.567L160.258 221.342H180.837L176.146 187.267ZM167.429 207.031C165.19 207.031 163.376 205.22 163.376 202.986C163.376 200.753 165.19 198.942 167.429 198.942C169.668 198.942 171.483 200.753 171.483 202.986C171.483 205.22 169.668 207.031 167.429 207.031Z",
    fill: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.518 187.119H156.939L161.505 221.342H182.084L177.518 187.119ZM169.3 207.031C167.061 207.031 165.247 205.22 165.247 202.986C165.247 200.753 167.061 198.942 169.3 198.942C171.539 198.942 173.353 200.753 173.353 202.986C173.353 205.22 171.539 207.031 169.3 207.031Z",
    fill: "#E5E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.106 219.95H106.879V228.304H324.106V219.95Z",
    fill: "#D7E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4995 121.626H51.7171V115.919H51.4146H48.189C40.484 115.919 34.2378 109.665 34.2378 101.95C34.2378 94.236 40.484 87.9821 48.189 87.9821H77.979C85.684 87.9821 91.9302 94.236 91.9302 101.95C91.9302 109.665 85.684 115.919 77.979 115.919H59.8072L55.4995 121.626Z",
    fill: "white",
    stroke: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2146 87.6792H52.4245C44.5524 87.6792 38.1708 94.0687 38.1708 101.95C38.1708 109.832 44.5524 116.222 52.4245 116.222H55.6501V121.929L64.1933 116.222H82.2146C90.0867 116.222 96.4683 109.832 96.4683 101.95C96.4683 94.0687 90.0867 87.6792 82.2146 87.6792Z",
    fill: "#EAFFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6411 97.2341H82.2641",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6411 101.475H70.1627",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6411 105.716H76.2134",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6 80.0941H273.223",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6 84.3348H261.121",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6 88.5755H267.172",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.417 104.828H271.912L267.728 99.1207H271.551C279.256 99.1207 285.502 92.8668 285.502 85.1523C285.502 77.4377 279.256 71.1839 271.551 71.1839H241.761C234.056 71.1839 227.81 77.4377 227.81 85.1523C227.81 92.8668 234.056 99.1207 241.761 99.1207H259.874L268.417 104.828Z",
    fill: "white",
    stroke: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.258 104.564V99.1207H275.787C283.492 99.1207 289.738 92.8668 289.738 85.1523C289.738 77.4377 283.492 71.1839 275.787 71.1839H245.997C238.292 71.1839 232.045 77.4377 232.045 85.1523C232.045 92.8668 238.292 99.1207 245.997 99.1207H264.109L272.258 104.564Z",
    fill: "white",
    stroke: "#18233D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6 80.0941H273.223",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6 84.3348H261.121",
    stroke: "#18233D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6 88.5755H267.172",
    stroke: "#18233D",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 334,
    height: 229,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansModal);
export default __webpack_public_path__ + "static/media/plans-modal.24befa5898390f8e33c67a95c15d8575.svg";
export { ForwardRef as ReactComponent };